import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import logoBlack from "@/assets/nbt-logo-black.png.asset.json";
import logoWhite from "@/assets/logo-white.webp";

interface BrandMarkProps {
  className?: string;
  size?: "sm" | "md" | "lg";
  to?: string | null;
  inverted?: boolean;
}

const sizeClasses = {
  sm: "h-7",
  md: "h-10",
  lg: "h-14",
};

const BrandMark = ({ className, size = "md", to = "/", inverted = true }: BrandMarkProps) => {
  const mark = (
    <img
      src={inverted ? logoWhite : logoBlack.url}
      alt="NBT Podcast"
      className={cn("w-auto select-none", sizeClasses[size], className)}
    />
  );

  if (!to) return mark;
  return (
    <Link to={to} aria-label="NBT Podcast — Inicio" className="inline-flex shrink-0">
      {mark}
    </Link>
  );
};

export default BrandMark;
